import * as React from 'react';
import {Checkbox} from '@sail/ui';

export const Invalid = () => {
  return <Checkbox label="This Checkbox is in an invalid state." invalid />;
};
